import { useAppSelector } from '../state/hooks'
import Colors from '../constants/Colors'

export const useOrganizationStyles = () => {
	const {
		appDisplayOptions: { styles },
	} = useAppSelector(state => state.settings)

	const { backgroundColor, hasBoxShadow, buttonAlternateColor } = styles

	return {
		...Colors.custom,
		appBackground: backgroundColor || Colors.custom.appBackground,
		hasBoxShadow,
		buttonAlternateColor,
	}
}
